import React from 'react';
import { HexColorPicker } from 'react-colorful';
import { parseHexColor } from '../utils/branding';

/**
 * Saturation/lightness area + hue strip + hex field (react-colorful).
 * @param {{ label?: string; value: string; onChange: (v: string) => void; fallbackHex: string; placeholder?: string }} props
 */
export default function BrandingColorField({ label, value, onChange, fallbackHex, placeholder = '#000000' }) {
  const pickerColor = parseHexColor(value) || fallbackHex;

  return (
    <div style={{ marginBottom: 20 }}>
      {label ? (
        <label style={{ display: 'block', fontSize: 13, color: 'var(--cc-text-muted)', marginBottom: 10 }}>{label}</label>
      ) : null}
      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div
          style={{
            borderRadius: 12,
            overflow: 'hidden',
            border: '1px solid var(--branding-app-surface-panel-border)',
            boxShadow: '0 2px 8px rgba(15,23,42,0.06)',
          }}
        >
          <HexColorPicker
            color={pickerColor}
            onChange={(hex) => onChange(hex)}
            style={{ width: 220, height: 168 }}
          />
        </div>
        <div style={{ flex: '1 1 160px', minWidth: 160, paddingTop: 4 }}>
          <div style={{ fontSize: 11, color: 'var(--cc-text-muted)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Hex
          </div>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            spellCheck={false}
            style={{
              width: '100%',
              boxSizing: 'border-box',
              padding: '10px 12px',
              borderRadius: 8,
              border: '1px solid var(--branding-app-surface-panel-border)',
              fontSize: 14,
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
              background: 'var(--cc-card-bg)',
              color: 'var(--cc-text-primary)',
            }}
          />
        </div>
      </div>
    </div>
  );
}
